import { useState } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import Selector from 'modules/core/components/Selector'
import i18n from 'modules/core/lib/i18n'

import teams from 'modules/teams/store/collections/teams'

interface TeamMultiselectorProps {
  teamIds: number[] | null | undefined
  form: Form
}

const TeamMultiselector = ({ teamIds, form }: TeamMultiselectorProps) => {
  const [teamsIds, setTeamsIds] = useState(teamIds ?? [])

  const handleChangeTeams = (ids: number[]) => {
    setTeamsIds(ids)
    form.get('team_ids').set(ids)
  }
  const teamOptions = teams.map((x) => {
    const { id, name } = x.attributes
    return (
      <Selector.Option key={id} value={id} label={name} searchValue={name}>
        <Box width="full" overflowY="hidden">
          <Text.Normal size="200" weight="medium" ellipsis>
            {name}
          </Text.Normal>
        </Box>
      </Selector.Option>
    )
  })

  return (
    <Selector.Popover
      inputStyle="tags"
      label={i18n.t('settings.permissions.visibility.choices.dynamic_group_options.team')}
      blankLabel={i18n.t('common.empty')}
      allSelectedLabel={i18n.t('common.all')}
      placeholder={i18n.t('common.select')}
      searchPlaceholder={i18n.t('common.search')}
      icon="manager"
      value={teamsIds ? teamsIds : []}
      onChange={(ids) => handleChangeTeams(ids as number[])}
      onToggle={(isOpen) => !isOpen}
      isMultiSelect
      maxHeight="s400"
    >
      {teamOptions}
    </Selector.Popover>
  )
}
export default observer(TeamMultiselector)
